import 'babel-polyfill'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()

import Vue from 'vue'
import App from '@/App.vue'
import store from '@plugin/store'
import i18n from '@plugin/i18n'
import router, { resetRouter } from '@plugin/router'

import '@plugin/icons'

import '@plugin/element/index.js'
import '@utils/index'

import '@/assets/styles/theme.scss'
import '@/assets/fonticons/transfer-icons/iconfont.css'
import VXETable from 'vxe-table'
import 'xe-utils'
// import _ from 'lodash'
// Vue.prototype._ = _
// Vue.prototype.deepCopy = _.cloneDeep
// Vue.prototype.isEmpty = _.isEmpty

Vue.config.productionTip = false
Vue.use(VXETable)

store.dispatch('menu/getRoutesByMenus').then((routes) => {
  resetRouter(routes)
  // 添加一个不可删除的首页标签
  if (store.getters.menus.matchedName === 'Root.Setting') {
    store.dispatch('tagsView/addVisitedView', router.resolve({ name: 'Root.Setting.Dashboard' }).route)
  } else {
    store.dispatch('tagsView/addVisitedView', router.resolve({ name: 'Dashboard' }).route)
  }
  if (!routes.length) {
    store.commit('app/SET_LOGIN_INFO')
  }
  new Vue({
    router,
    store,
    // eslint-disable-next-line
    i18n: i18n as any,
    render: (h) => h(App)
  }).$mount('#app')
})
